import React from 'react';
import DatePicker from 'react-datepicker';
import { Form } from 'semantic-ui-react';
import { ru } from 'date-fns/locale';
import { UserRole, hasRole } from '../../helpers/UserRole';
import {RepeatTypes} from "../../enums/EventEnums";
import MaskedDatePicker from './MaskedDatePicker';

interface EventCancellationTimeProps {
    label: string;
    fromDate: Date | null;
    toDate: Date | null;
    repeatType: RepeatTypes | '';
    onFromDateChange: (date?: Date) => void;
    onToDateChange: (date?: Date) => void;
    disabled?: boolean;
    massive?: boolean;
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

export const EventCancellationTime: React.FC<EventCancellationTimeProps> =
({
    label,
    fromDate,
    toDate,
    repeatType= RepeatTypes.NO_REPEATABLE,
    onFromDateChange,
    onToDateChange,
    disabled = false,
    massive = false,
    onKeyDown,
}) => {
    const isDisabled = disabled || hasRole(UserRole.OBSERVER) || massive;

    if ([RepeatTypes.NO_REPEATABLE, ''].includes(repeatType as any)) {
        return null;
    }

    return (
        <Form.Field>
            <label>{label}</label>
            <div style={{ display: "flex" }}>
                <div style={{ width: "161px" }}>
                    <MaskedDatePicker
                        disabled={isDisabled}
                        selected={fromDate}
                        onChange={onFromDateChange}
                        onKeyDown={onKeyDown}
                    />
                </div>
                <span style={{ lineHeight: "38px" }}> - </span>
                <div style={{ width: "161px" }}>
                    <MaskedDatePicker
                        disabled={isDisabled}
                        selected={toDate}
                        onChange={onToDateChange}
                        onKeyDown={onKeyDown}
                    />
                </div>
            </div>
        </Form.Field>
    );
};